/** Native BLE bridge reports `connectionState === 2` while the session is live. */
export const BLE_SETTINGS_CONNECTED_STATE = 2;

export function isBleSettingsSessionReady(connectionState?: number): boolean {
	return connectionState === BLE_SETTINGS_CONNECTED_STATE;
}
